import { render, staticRenderFns } from "./StaticAssessmentView.vue?vue&type=template&id=4de2b27c&scoped=true&"
import script from "./StaticAssessmentView.vue?vue&type=script&lang=js&"
export * from "./StaticAssessmentView.vue?vue&type=script&lang=js&"
import style0 from "./StaticAssessmentView.vue?vue&type=style&index=0&id=4de2b27c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2b27c",
  null
  
)

export default component.exports